import styled from 'styled-components'
import { borderRadius, spacing } from '../../../styles/styles'

export const Card = styled.div`
  margin-bottom: ${spacing.md};
  border-radius: ${borderRadius};
  background: white;
`
